import { Routes } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { ForgotPasswordPageComponent } from './pages/forgot-password-page/forgot-password-page.component';
import { CreateAccountPageComponent } from './pages/create-account-page/create-account-page.component';
import { CollegesComponent } from './pages/colleges/colleges.component';
import { UsersComponent } from './pages/users/users.component';
import { AdminsComponent } from './pages/admins/admins.component';
import { VendorsComponent } from './pages/vendors/vendors.component';
import { CampusesComponent } from './pages/campuses/campuses.component';
import { PostsComponent } from './pages/posts/posts.component';
import { AccountInfoComponent } from './pages/account-info/account-info.component';
import { VendorReviewComponent } from './pages/vendors/vendor-review/vendor-review.component';
import { AdminViewListingsComponent } from './pages/admin-view-listings/admin-view-listings.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'create-account',
    component: CreateAccountPageComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordPageComponent,
  },
  {
    path: 'login',
    component: LoginPageComponent,
  },
  {
    path: 'home',
    component: HomePageComponent,
  },
  {
    path: 'colleges',
    component: CollegesComponent,
  },
  {
    path: 'users',
    component: UsersComponent,
  },
  {
    path: 'admins',
    component: AdminsComponent,
  },
  {
    path: 'vendors',
    component: VendorsComponent,
  },
  {
    path: 'campuses',
    component: CampusesComponent,
  },
  {
    path: 'campuses/:collegeId',
    component: CampusesComponent,
  },
  {
    path: 'posts',
    component: PostsComponent,
  },
  {
    path: 'account-info',
    component: AccountInfoComponent,
  },
  {
    path: 'vendor/review/:id',
    component: VendorReviewComponent,
  },
  {
    path: 'all-listings',
    component: AdminViewListingsComponent,
  },
];
